import React from 'react';
import { Box, Card, CardContent, Typography, Grid, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';
import { useAuth } from '../../contexts/AuthContext';

const ReportsHome = () => {
  const { t } = useTranslation();
  const { hasPermission } = useAuth();
  const navigate = useNavigate();

  const sections = [
    {
      title: t('reports.sectionInventorySales'),
      items: [
        {
          title: t('reports.productInventory'),
          description: t('reports.productInventoryDescription'),
          path: '/reports/product-inventory',
          permission: 'reports.view',
        },
        {
          title: t('reports.totalSales'),
          description: t('reports.totalSalesDescription'),
          path: '/reports/total-sales',
          permission: 'reports.view',
        },
        {
          title: t('reports.salesByProduct'),
          description: t('reports.salesByProductDescription'),
          path: '/reports/sales-by-product',
          permission: 'reports.view',
        },
        {
          title: t('reports.earningsByBatch'),
          description: t('reports.earningsByBatchDescription'),
          path: '/reports/earnings-by-batch',
          permission: 'reports.view',
        },
      ],
    },
    {
      title: t('reports.sectionPayments'),
      items: [
        {
          title: t('reports.paymentsActiveMembershipsByMonth'),
          description: t('reports.paymentsActiveMembershipsByMonthDescription'),
          path: '/reports/payments/active-memberships-by-month',
          permission: 'reports.payments.active_memberships_by_month',
        },
        {
          title: t('reports.paymentsActiveClientsCounts'),
          description: t('reports.paymentsActiveClientsCountsDescription'),
          path: '/reports/payments/active-clients-counts',
          permission: 'reports.payments.active_clients_counts',
        },
        {
          title: t('reports.paymentsIncomeByDateRange'),
          description: t('reports.paymentsIncomeByDateRangeDescription'),
          path: '/reports/payments/income-by-date-range',
          permission: 'reports.payments.income_by_date_range',
        },
      ],
    },
    {
      title: t('reports.sectionClinic'),
      items: [
        {
          title: t('reports.clinicAppointmentBookings'),
          description: t('reports.clinicAppointmentBookingsDescription'),
          path: '/reports/clinic/appointment-bookings',
          permission: 'reports.view',
        },
      ],
    },
    {
      title: t('reports.sectionCleaning'),
      items: [
        {
          title: t('reports.cleaningHoursWagesByCleaner'),
          description: t('reports.cleaningHoursWagesByCleanerDescription'),
          path: '/reports/cleaning/hours-wages-by-cleaner',
          permission: 'reports.view',
        },
        {
          title: t('reports.cleaningHoursByClient'),
          description: t('reports.cleaningHoursByClientDescription'),
          path: '/reports/cleaning/hours-by-client',
          permission: 'reports.view',
        },
      ],
    },
    {
      title: t('reports.sectionSchool'),
      items: [
        {
          title: t('reports.attendanceStudentSummary'),
          description: t('reports.attendanceStudentSummaryDescription'),
          path: '/reports/attendance/student-summary',
          permission: 'attendances.view',
        },
      ],
    },
  ];

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" fontWeight={700}>
          {t('reports.title')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('reports.chooseReport')}
        </Typography>
      </Box>

      {sections.map((section) => {
        const visible = section.items.filter((it) => hasPermission(it.permission));
        if (visible.length === 0) return null;
        return (
          <Box key={section.title} sx={{ mb: 3 }}>
            <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>
              {section.title}
            </Typography>
            <Grid container spacing={2}>
              {visible.map((item) => (
                <Grid key={item.path} item xs={12} md={6} lg={4}>
                  <Card variant="outlined" sx={{ height: '100%' }}>
                    <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                      <Typography fontWeight={700} sx={{ mb: 0.5 }}>
                        {item.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        {item.description}
                      </Typography>
                      <Box sx={{ mt: 'auto' }}>
                        <Button variant="contained" onClick={() => navigate(item.path)}>
                          {t('reports.openReport')}
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        );
      })}
    </Box>
  );
};

export default ReportsHome;

